import React, { useState, useEffect, useRef } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import DataTable from "react-data-table-component";

export default function List_Usuarios({ history }) {
  const [prod, setProd] = useState([]);
  const [loading, setLoading] = useState("");
  const [busca, setBusca] = useState("");
  const [buscaEmpresa, setBuscaEmpresa] = useState("");
  const [rowsSel, setRowsSel] = useState([]);
  const [isMaster, setIsMaster] = useState(false);
  const userid = localStorage.getItem("sgiuserid");

  const filtroNomeRef = useRef("");
  const filtroEmpresaRef = useRef("");
  filtroNomeRef.current = busca;
  filtroEmpresaRef.current = buscaEmpresa;

  const checkadmin = () => {
    const b_admin = localStorage.getItem("sgiadmin");
    if (b_admin != "true") history.push("/painel");
  };

  async function loadProd(clear) {
    if (userid === null) {
      return;
    }
    const textoNome = filtroNomeRef.current;
    const textoEmpresa = filtroEmpresaRef.current;
    let query = "";
    let options;

    if (localStorage.getItem("sgimaster") === "true") {
      query = "/treinamentos/usuarios";
      options = {};
    } else {
      query = "/treinamentos/usuarios/empresa/tenantid";
      options = {
        headers: { "x-tenantid": localStorage.getItem("sgiempresaid") },
      };
    }
    const response = await api.get(query, options);
    const data = await response.data;
    const nomeEmpresaDoUsuario = (item) => {
      const emp = item.idempresa;
      if (emp && typeof emp === "object" && emp.nome) return emp.nome;
      return "";
    };
    if ((textoNome === "" && textoEmpresa === "") || clear === true) {
      setProd(data);
    } else {
      setProd(
        data.filter((item) => {
          const okNome =
            !textoNome ||
            (item.nome &&
              item.nome.toLowerCase().includes(textoNome.toLowerCase()));
          const nomeEmpresa = nomeEmpresaDoUsuario(item).toLowerCase();
          const okEmpresa =
            !textoEmpresa ||
            nomeEmpresa.includes(textoEmpresa.toLowerCase());
          return okNome && okEmpresa;
        })
      );
    }
    setTimeout(() => {
      setLoading(false);
    }, 800);
  }

  function efetivaBusca(clear) {
    setLoading(true);
    loadProd(clear);
  }

  const handleChange = (state) => {
    setRowsSel(state.selectedRows);
  };

  const goToPage = (state) => {
    history.push("/usuario/" + state._id);
  };

  useEffect(() => {
    setLoading(true);
    setIsMaster(localStorage.getItem("sgimaster"));
    checkadmin();
    loadProd();
    setTimeout(() => {
      if (document.getElementById("menu_usuario")) {
        document.getElementById("menu_usuario").className = "active";
      }
    }, 50);

    
  }, []);

  const CustomAcesso = ({ row }) =>
    row.isMaster ? "Master" : row.isAdmin ? "Administrador" : "Usuario";

  const nomeEmpresaUsuario = (row) =>
    row.idempresa && typeof row.idempresa === "object" && row.idempresa.nome
      ? row.idempresa.nome
      : "—";

  const columns = [
    {
      name: "Nome",
      selector: (row) => row.nome,
      sortable: true,
    },
    {
      name: "Empresa",
      selector: (row) => nomeEmpresaUsuario(row),
      sortable: true,
    },
    {
      name: "E-mail",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Acesso",
      selector: (row) => row.admin,
      sortable: false,
      cell: (row) => <CustomAcesso row={row} />,
    },
  ];

  async function handleRemove(id, item) {
    if (rowsSel.length > 0) {
      if (window.confirm("Confirma remoção dos itens selecionados ?")) {
        setLoading(true);
        rowsSel.map(async (item) => {
          await api
            .delete("treinamentos/usuarios/" + item._id)
            .then((res) => {
              if (res.data.error != undefined) {
                alert(res.data.error);
                setLoading(false);
                return;
              } else {
                loadProd();
                setLoading(false);
              }
            })
            .catch((error) => {
              alert(error);
              setLoading(false);
              return;
            });
        });
      }
    } else {
      alert("Nenhum registro selecionado !");
    }
  }

  return (
    <>
      <Header />
      <SideMenu />

      <div>
        <div className="content-wrapper">
          <section className="content-header">
            <h1>
              Usuários<small>( tabela usuários )</small>
            </h1>
          </section>

          <section className="content">
            <div className="row">
              <div className="col-xs-12">
                <div className="box box-primary">
                  <div className="box-body table-responsive">
                    <div className="col-md-12 nopadding">
                      <div
                        className="col-md-6 nopadding"
                        style={{ paddingLeft: 0, marginLeft: -10 }}
                      >
                        <button
                          type="button"
                          className="btn btn-success btn-flat margin"
                          onClick={() => {
                            history.push("/usuario/novo");
                          }}
                        >
                          Novo Usuário
                        </button>
                        <button
                          type="button"
                          className="btn btn-danger btn-flat margin"
                          onClick={() => {
                            handleRemove("", "");
                          }}
                        >
                          Remover Selecionados
                        </button>
                        <button
                          type="button"
                          className="btn btn-info btn-flat margin"
                          onClick={() => {
                            setBusca("");
                            setBuscaEmpresa("");
                            efetivaBusca(true);
                          }}
                        >
                          Limpar Filtros
                        </button>
                      </div>
                    </div>
                    <div className="col-md-12">
                        <div className="col-md-3 pull-right">
                        <div class="input-group" >
                          <input
                            type="text"
                            name="message"
                            placeholder="Filtrar por Nome"
                            class="form-control"
                            value={busca}
                            onChange={(event) => setBusca(event.target.value)}
                            onKeyUp={(event) => {
                              if (event.key === "Enter") {
                                efetivaBusca(false);
                              }
                            }}
                          ></input>
                          <span class="input-group-btn">
                            <button type="button" class="btn btn-flat" onClick={() => {
                            efetivaBusca(false);
                          }}>
                              Filtrar
                            </button>
                          </span>
                        </div>
                        </div>
                        {isMaster == "true" && 
                        <>
                        <div className="row"> </div>
                          <div className="col-md-3 pull-right">
                          <div class="input-group">
                            <input
                              type="text"
                              name="empresa"
                              placeholder="Filtrar por Empresa"
                              class="form-control"
                            value={buscaEmpresa}
                            onChange={(event) => setBuscaEmpresa(event.target.value)}
                              onKeyUp={(event) => {
                                if (event.key === "Enter") {
                                  efetivaBusca(false);
                                }
                              }}
                            ></input>
                            <span class="input-group-btn">
                              <button type="button" class="btn btn-flat" onClick={() => {
                            efetivaBusca(false);
                          }}>
                                Filtrar
                              </button>
                            </span>
                          </div>
                        </div>
                      </>
                      }
                      </div>


                    {loading && (
                      <div
                        style={{ alignItems: "center", textAlign: "center" }}
                      >
                        <img src={carregando} width="80"></img>
                      </div>
                    )}

                    <DataTable
                      columns={columns}
                      data={prod}
                      onRowClicked={goToPage}
                      selectableRows
                      pointerOnHover
                      highlightOnHover
                      onSelectedRowsChange={handleChange}
                      noDataComponent={""}
                    />
                  </div>
                  {/* /.box-body */}
                </div>
                {/* /.box */}
              </div>
            </div>
          </section>
          {/* /.content */}
        </div>
      </div>

      <Footer />
    </>
  );
}

//nome,
//descr,
//preco,
//imagem,
//promocao,
//idestabelecimento
